import { DELETE, GET, PATCH, POST, POSTSSE, PUT } from "../axios/apiService";

export const getUser = async () => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user`;
  return GET(url, {
    isExtension: true,
  });
};

export const logOutUser = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/logout`;
  return POST(url, {}, { withCredentials: true, withXSRFToken: true });
};

export const setActiveWorkspace = async (id) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user/set-active-workspace/${id}`;
  return PUT(url);
};
export const getEnrichmentDetailsById = async ({ options, id }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/enrich/${id}`;
  return GET(url, options);
};

// same
export const enrichProfile = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/enrich`;
  return POST(url, data, options);
};
export const revealContact = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/enrich`;
  return POST(url, data, options);
};
// same

export const enrichContact = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/people`;
  return POST(url, data, options);
};
export const createPeople = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/people`;
  return POST(url, data, options);
};

export const searchPeople = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/people/search`;
  return POST(url, data, options);
};
export const createContactsV2Resolve = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/contacts/resolve`;
  return POST(url, data, { skipErrorToast: true, ...options });
};
export const createContactsV2 = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/contacts`;
  return POST(url, data, { skipErrorToast: true, ...options });
};
export const getContactDetailsById = async ({ options, id }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/contacts/${id}?include_enrichment_lists=true&include_tasks=true&include_actions=true`;
  return GET(url, options);
};
export const searchContactsV2 = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/contacts/search`;
  return POST(url, data, options);
};
export const getWorkspaceContacts = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/contacts${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getEnrichedDataByPersonId = async ({ options, id }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/people/${id}`;
  return GET(url, options);
};
export const getEnrichedDataByContactId = async ({ options, id }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/contacts/${id}`;
  return GET(url, options);
};

export const enrichCompany = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich-company`;
  return POST(url, data, options);
};

export const getIntegrations = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations`;
  return GET(url, options);
};

export const verifyEnrichedEmail = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/verify/email`;
  return POST(url, data, options);
};

export const feedbackForEnrichedPhoneEmail = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/contacts/record-feedback`;
  return POST(url, data, options);
};

export const setPreferences = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user/preferences`;
  return PATCH(url, data, options);
};

export const setJobFunction = async ({ data }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user/profile`;
  return PATCH(url, data);
};

export const createAIMessage = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/ai-messaging/create`;
  return POST(url, data, options);
};

export const analyseProspect = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/contacts/${data.contact_id}/analyse-prospect`;
  return POST(url, {}, options);
};

export const getLists = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/lists`;
  return GET(url, options);
};

export const createList = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/lists`;
  return POST(url, data, options);
};

export const addContactToList = async ({ data, options, listId }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/lists/${listId}/contacts`;
  return POST(url, data, options);
};
export const addCompanyToList = async ({ data, options, listId }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/lists/${listId}/companies`;
  return POST(url, data, options);
};

export const createOrg = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/organizations`;
  return POST(url, data, options);
};

export const getOrg = async ({ id, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/organizations/${id}`;
  return GET(url, options);
};

export const enrichOrg = async ({ id, domain = false, options }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/organizations/${
    domain ? "domain" : "linkedin"
  }/${id}`;
  if (!id || id === null) {
    return;
  }
  return GET(url, options);
};

export const isCompanyInCRM = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/search`;
  return POST(
    url,
    data,
    {
      withCredentials: false,
      skipErrorToast: true,
      ...options,
    },
    false
  );
};
export const matchCompanyInCRM = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/match`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};
export const updateRecordInCRM = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/update`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};
export const createRecord = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/create`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const getSavedCRMConfig = async ({ options, crmConfigId, crmKey }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/objects`;
  return GET(url, options);
};

export const diffRecordCheckerInCRM = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/analyse-record`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const fetchRecordInCRM = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/bulk-records`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const getCompanyInsights = async ({ options, organization_id }) => {
  const url = `${process.env.REACT_APP_API_INSIGHTS_BASE_URL}/api/v1/insights/${organization_id}`;
  return GET(url, options);
};

export const getCompanyHierarchy = async ({ options, organization_id }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/organizations/corporate-hierarchy?organization_id=${organization_id}`;
  return GET(url, options);
};
export const createCompanyHierarchy = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/organizations/corporate-hierarchy`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const enrichCompanyHierarchy = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/organizations/enrich/corporate-hierarchy-level`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const crmBulkSearch = async ({ data, options = {}, configId, onStream }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/batch/search`;

  return POSTSSE(url, data, {
    ...options,
    onStream,
    withCredentials: false,
    skipErrorToast: true,
  });
};

export const getTechnography = async ({ options, organization_id }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/organizations/${organization_id}/technography`;
  return GET(url, {
    skipErrorToast: true,
    ...options,
  });
};
